import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { DepartmentDropdownItem } from 'components/queue-view/models/dropdown-item.interface';
import { TabSettings } from 'components/queue-view/live-workload-tab/interfaces/tab-settings';
import { BcConfigService } from 'common/config/provider';
import { CoolLocalStorage } from '@angular-cool/storage';
import { bcSessionKeys } from 'common/common/constants/session-keys';
import { LiveWorkloadTab } from 'components/queue-view/live-workload-tab/models/live-workload-tab';
import { CommonAuthService } from 'common/auth/common-auth.service';

@Component({
  selector: 'app-live-workload-tab',
  templateUrl: './live-workload-tab.component.html',
  styleUrls: ['./live-workload-tab.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LiveWorkloadTabComponent implements OnInit {
  @Input()
  selectedDepartments: DepartmentDropdownItem[];

  @Output()
  navigateToOtherTab = new EventEmitter<TabSettings>();

  @Output()
  filterDepartments = new EventEmitter<string[]>();

  public readonly liveWorkloadTab = LiveWorkloadTab;
  public showLiveWorkloadTabs: boolean;
  public activeTab: LiveWorkloadTab;
  public readonly isHybrid = this._commonAuth.isHybrid();

  constructor(private _bcConfig: BcConfigService,
              private _localStorageService: CoolLocalStorage,
              private _commonAuth: CommonAuthService) {
  }

  ngOnInit() {
    this.showLiveWorkloadTabs = this._bcConfig.current.features.showLiveWorkloadTabs;
    this.activeTab = this.showLiveWorkloadTabs
      ? this.getStoredActiveTab() || LiveWorkloadTab.DEPARTMENTS
      : LiveWorkloadTab.AGENTS;
  }

  public onNavigate(event: TabSettings): void {
    this.navigateToOtherTab.emit(event);
  }

  public setActiveTab(tabName: LiveWorkloadTab): void {
    this.activeTab = tabName;
    this._localStorageService.setItem(bcSessionKeys.storage.liveWorkloadSelectedTab, tabName);
  }

  public onNavigateToAgentsTab(departmentIds: string[]): void {
    this.filterDepartments.emit(departmentIds);
    this.activeTab = LiveWorkloadTab.AGENTS;
  }

  private getStoredActiveTab(): LiveWorkloadTab {
    const storedValue = this._localStorageService.getItem(bcSessionKeys.storage.liveWorkloadSelectedTab);
    const storedKey = Object.keys(LiveWorkloadTab).find(key => LiveWorkloadTab[key] === storedValue);
    return storedKey && LiveWorkloadTab[storedKey] || null;
  }
}
